import { onContentErrorHooks } from 'src/constrains/SalesChannelPreviewPageComponents/tools';
import { useErrorOnChange2 } from 'src/constrains/SalesChannelPreviewPageComponents/tools';
import { dispatch } from '@/src/store';

const useError = (args) => {
  const {
    data,
    open,
    display,
    validation,
    isPrimary,
    stamp,
    errorDisplayHasError,
    onErrorChange,
    id,
    isRedux,
  } = args;

  const {
    currentSpecificError,
    currentGeneralError,
    specificError, //->对应现在应该显示error,对应pDataError里面的数据
    generalError, //->对应现在应该显示error,对应pDataError里面的数据
    currentHasPreviousError, //->对应现在应该显示HasError,对应pDataError里面的数据
    currentHasError,
  } = validation
    ? onContentErrorHooks({
        isContentGroup: false,
        data: data,
        isOpen: open,
        display: display,
        validation: (x) => {
          return validation(x, { isPrimary });
        },
        stamp,
      })
    : {
        specificError: {},
        generalError: [],
        currentHasPreviousError: false,
        currentHasError: false,
        currentSpecificError: false,
        currentGeneralError: false,
      };
  //console.log('123123', specificError, currentSpecificError);
  useErrorOnChange2({
    latestHasError: currentHasError,
    previousHasError: errorDisplayHasError,
    dispatch: isRedux ? dispatch : null,
    action: onErrorChange,
    id,
  });

  return {
    currentSpecificError,
    currentGeneralError,
    specificError,
    generalError,
    currentHasPreviousError,
    currentHasError,
  };
};

export { useError };
